(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-header-timer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const activeTimers = new Map();

  function parseEnd(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})([+-])(\d{2}):(\d{2})$/.exec(value || '');
    if (!match) return NaN;
    const [, y, mo, d, h, mi, s, , oh, om] = match;
    const year = Number(y);
    const month = Number(mo);
    const day = Number(d);
    const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month < 1 || month > 12 || day < 1 || day > days[month - 1] ||
        Number(h) > 23 || Number(mi) > 59 || Number(s) > 59 ||
        Number(oh) > 14 || Number(om) > 59 || (Number(oh) === 14 && Number(om) !== 0)) return NaN;
    return Date.parse(value);
  }

  function stop(timer) {
    clearInterval(activeTimers.get(timer));
    activeTimers.delete(timer);
  }

  function setVisible(element, visible) {
    if (!element) return;
    element.hidden = !visible;
    if (visible) element.style.removeProperty('display');
    else element.style.display = 'none';
  }

  function init(root) {
    const productCount = document.querySelector('div#collection-info span');
    if (productCount) productCount.textContent = productCount.textContent.replace(/products/i, 'selling fast');

    root.querySelectorAll('[data-cw-timer]').forEach((timer) => {
      stop(timer);
      const banner = timer.closest('[data-cw-sale-banner]');
      const hasCopy = Boolean(banner && banner.querySelector('[data-cw-sale-copy]'));
      const customEnd = parseEnd(timer.dataset.end);
      const secondsField = timer.querySelector('.cw-seconds');
      const fields = ['.cw-days', '.cw-hours', '.cw-mins'].map((selector) => timer.querySelector(selector));

      function update() {
        if (!timer.isConnected) { stop(timer); return false; }
        const now = new Date();
        let end = customEnd;
        if (timer.dataset.mode === 'daily') {
          const midnight = new Date(now);
          midnight.setHours(24, 0, 0, 0);
          end = midnight.getTime();
        } else if (timer.dataset.mode === 'weekly') {
          const sundayEnd = new Date(now);
          sundayEnd.setDate(now.getDate() + ((7 - now.getDay()) % 7));
          sundayEnd.setHours(23, 59, 59, 999);
          if (sundayEnd.getTime() <= now.getTime()) sundayEnd.setDate(sundayEnd.getDate() + 7);
          end = sundayEnd.getTime();
        }
        const remaining = end - now.getTime();
        const visible = Number.isFinite(remaining) && remaining > 0 && fields.every(Boolean);
        setVisible(timer, visible);
        setVisible(banner, hasCopy || visible);
        if (!visible) { stop(timer); return false; }
        const seconds = Math.floor(remaining / 1000);
        const minutes = Math.floor(seconds / 60);
        if (secondsField) secondsField.textContent = String(seconds % 60).padStart(2, '0');
        const values = [Math.floor(minutes / 1440), Math.floor(minutes / 60) % 24, minutes % 60];
        fields.forEach((field, index) => { field.textContent = String(values[index]).padStart(2, '0'); });
        return true;
      }

      if (update()) activeTimers.set(timer, setInterval(update, 1000));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-cw-timer]').forEach(stop);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
